<!--suppress ALL -->
<template>
  <v-container class="pa-0" grid-list-md fluid>
    <v-data-iterator
      :items="items"
      :pagination.sync="pagination"
      :rows-per-page-items="[]"
      :total-items="total"
      content-tag="div"
      content-class="v-layout"
      :no-data-text="loading ? '加载中...': '没有记录'"
      :no-results-text="loading ? '加载中...' : '没有记录'"
      row
      wrap
    >
      <template slot="item" slot-scope="props">
        <v-flex
          class="pa-1"
          xs12
          sm6
          md4
          lg3
        >
          <v-card v-ripple @click="goDetails(props.item)">
            <v-card-title>
              <h4>{{ props.item.plate }}【{{typeMap[props.item.type]}}】</h4>
              <v-spacer></v-spacer>
              <span :class="props.item.isExpire ? 'grey--text':'primary--text'">
                {{props.item.isExpire ? '失效':'有效'}}
              </span>
            </v-card-title>
            <v-divider></v-divider>
            <v-list dense>
              <v-list-tile>
                <v-list-tile-content>访客手机:</v-list-tile-content>
                <v-list-tile-content class="align-start">{{ props.item.phone }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>开始时间:</v-list-tile-content>
                <v-list-tile-content class="align-start">{{ $L.time.stringify(props.item.startDatetime) }}
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>结束时间:</v-list-tile-content>
                <v-list-tile-content class="align-start">{{ $L.time.stringify(props.item.endDatetime) }}
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      </template>
      <template slot="pageText" slot-scope="props">
        <v-layout align-center row>
          <span>{{props.pageStart}} - {{props.pageStop}} 条，共 {{props.itemsLength}} 条</span>
        </v-layout>
      </template>
    </v-data-iterator>
  </v-container>
</template>

<script>
export default {
  name: 'reservationList',
  props: {
    // history: {type: Boolean, default: false}
  },
  data: () => ({
    rowsPerPageItems: [5, 10, 15, 20, 30, 50, 100],
    pagination: {
      sortBy: 'creationTime',
      descending: true,
      page: 1,
      rowsPerPage: 10
    },
    loading: false,
    items: [],
    total: 0,
    typeMap : {
      person: '个人预约',
      org: '单位预约',
      admin:'高级预约'
    },
    reservationType:[]
  }),
  watch: {
    pagination: {
      handler () {
        this.getItems()
      },
      deep: true
    }
  },
  async created(){
  },
  methods: {
    async dealPermission(){
      let permission = await this.$store.dispatch('login/getPermission')
      if (permission.wechat.personalReservation_wx !== undefined) {
        this.reservationType.push( 'person')
      }
      if (permission.wechat.orgReservation_wx !== undefined) {
        this.reservationType.push( 'org')
      }
      if (this.reservationType.length === 0) {
        this.$router.push({name: 'AccessDeny'})
      }
    },
    goDetails (item) {
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'PersonalReservationDetailsWX',
          params: {plate: item.plate, item},
          query: {id: item.id}
        })
      }
    },
    async getItems () {
      this.loading = true
      try {
        let {items, amount} = await this.$store.dispatch('reservation/getReservations', {
          pagination: this.pagination,
          self: true,
          locate: ''
        })
        this.items = items
        console.log(items)
        this.total = amount
      }
      catch (e) {
        this.$L.error(e.message)
        this.items = []
        this.total = 0
      }
      finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>

</style>
